import { ChevronDownIcon, ChevronUpIcon, CreateTheme } from "@commonlibs";
import { spacingProxy as spacing } from "./spacing";
import typography from "./typography/typography";

const baseTheme: Omit<CreateTheme, "border"> = {
    typography,
    borderRadius: spacing[2],
    borderRadiusMd: spacing[3],
    borderRadiusLg: spacing[4],
    borderRadiusXl: spacing[6],
    borderRounded: "99999px",
    spacing,
    icons: {
        chevronDown: ChevronDownIcon,
        chevronUp: ChevronUpIcon,
    },
    breakpoints: {
        values: {
            smallMobile: 350,
            maxPageWidth: 767,
        },
    },
};

export default baseTheme;
